export const SCORM_CONTENT_TYPE_OPTIONS = {
  INITIAL: 0,
  REFRESHER: 1,
  REVISION: 2,
};

export const SCORM_LAUNCH_OPTIONS = {
  PREVIEW: 0,
  LAUNCH: 1,
};
